export default "__VITE_ASSET__YrCRE2ot__"